import { supportedLanguages } from "@lemmonhq/uikit";

const JURISDICTION_LANGUAGE_CONFIG: Record<string, string[]> = {
  GE: ["en", "ka"],
  CH: ["en", "de", "fr", "it"],
};

export const getSupportedLanguagesForJurisdictions = (
  jurisdictions: Array<string | null | undefined>,
) => {
  const configuredJurisdictions = [
    ...new Set(
      jurisdictions.filter((value): value is string => Boolean(value)),
    ),
  ].filter((jurisdiction) => JURISDICTION_LANGUAGE_CONFIG[jurisdiction]);
  const effectiveJurisdictions = configuredJurisdictions.length
    ? configuredJurisdictions
    : ["CH"];
  const allowedLanguageIds = new Set(
    effectiveJurisdictions.flatMap(
      (jurisdiction) => JURISDICTION_LANGUAGE_CONFIG[jurisdiction],
    ),
  );

  return supportedLanguages.filter((language) =>
    allowedLanguageIds.has(language.id),
  );
};
